import * as React from "react";

import header from "./coke-header.png";


interface Props {
  role?: "SPLASH" | "DETAILS" | "ENTERSPEED" | "SUCSSES";
  defaultHeader?: JSX.Element;
  size?: "large" | "normal";
}

interface FullscreenElement extends HTMLElement {
  webkitRequestFullscreen?: () => void;
}

const requestFullscreen = () => {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    const el: FullscreenElement = document.documentElement;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  }
};

const defaultHeroHeader = (size: "large" | "normal" = "normal") => (
  <div
    className="flex flex-col pt-4 items-center bg-bgBody justify-center"
    onClick={requestFullscreen}
  >
    <img src={header} className={size === "large" ? "h-20" : "h-14"} />
  </div>
);

const Hero: React.FC<Props> = ({
  role,
  size = "normal",
  defaultHeader = defaultHeroHeader(size),
}: Props) => {
  console.log(role);
  return defaultHeader;
};

export default Hero;
